<template>
  <div class="container-fluid">
    <div class="page-header">
      <div class="row">
        <div class="col-lg-12">
          <div class="page-header-left">
            <h3>{{title}}</h3>
            <ol class="breadcrumb">
              <li class="breadcrumb-item"></li>
            </ol>
          </div>
          <p class="mt-2" v-if="description">{{description}}</p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    title: {
      default: 'home'
    },
    main: {
      default: ''
    },
    description: {
      default: ''
    }
  }
}
</script>
